module.exports = __webpack_public_path__ + "img/map-hours-table-honda.132c70fe.png";